import * as yup from 'yup';
import * as formSchemaUtils from './formSchemaUtils';

const getAccessRequestFormSchema = () =>
  yup.object().shape({
    role: formSchemaUtils.stringRequired(),
    departmentOrExperiment: formSchemaUtils.stringRequired()
  });

export default getAccessRequestFormSchema;
